//#region  imports
import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
//#endregion imports

//#region  internal imports
import { AppDataService } from 'app/modules/authentication/services/appdata.service';
import { AuthenticationService } from 'app/modules/authentication/services/authentication.service';
import { RouteHistoryService } from '../services/route-history.service';
import { AuthenticationPath, ControlPanelPath } from '../common/route-constant';
//#endregion internal imports

@Injectable({
  providedIn: 'root',
})
export class AuthGuardService {
  isLoggedin = false;
  redirectUrl: string;

  constructor(
    private authService: AuthenticationService,
    private appDataService: AppDataService,
    private router: Router,
    private history: RouteHistoryService
  ) {}

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean> {
    // let last_route = this.history.getLastRoute();
    // this.appDataService.navigateUrl  = route.url == null || 'login' ? last_route :  state.url;

    // Save the URL user attempted to open
    if (state.url !== `/${AuthenticationPath.Login}`) {
      this.appDataService.navigateUrl = state.url;
    }

    return this.checkLogin();
  }

  checkLogin(): boolean {
    const token = this.authService.getToken();
    if (token && !this.isTokenExpired(token)) {
      return true;
    }
    if (token) {
      // Token exists but is expired — clean up before redirecting
      localStorage.clear();
    }
    this.router.navigateByUrl(`${AuthenticationPath.Login}`);
    return false;
  }

  private isTokenExpired(token: string): boolean {
    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      const expiryMs = payload.exp * 1000;
      return Date.now() >= expiryMs;
    } catch {
      // Malformed token — treat as expired
      return true;
    }
  }
}
